import {
  Center,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  MenuItem,
  MenuList,
  Spinner,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import Icon from '@chakra-ui/icon';
import { FaInfoCircle, FaTrash } from 'react-icons/fa';
import { FiExternalLink, FiTrash } from 'react-icons/all';
import { MultiSelect } from 'react-multi-select-component';
import { FiDownload } from 'react-icons/fi';
import download from 'downloadjs';
import { Link } from 'react-router-dom';
import { MultiSelectStrings } from '~/utils/multiSelectStrings';
import {
  Button,
  Footer,
  Heading,
  Input,
  Menu,
  Pagination,
  Select,
  StatusBadge,
  Table,
} from '~/components';
import {
  getSegmentoResppnsavelById,
  SegmentosVendaResponsavelAsView,
  useQueryParams,
  useUsersByGroup,
} from '~/hooks';
import { getGroupById, Group } from '~/hooks/useGroups';
import {
  getAccountManagerAsSelect,
  getCompaniesAsSelect,
  getCompaniesByGroupAsSelect,
  getCustomerSuccessAsSelect,
  getSalesSegmentAsSelect,
} from '~/services';
import api from '~/utils/api';
import { queryClient } from '~/utils/react-query';
import { SelectItem } from '~/types';
import { Card } from '~/components/Card';
import { ApplyForCertificateDialog } from '~/pages/Portal/Admin/Groups/ApplyForCertificateDialog';
import {
  useGroupCertificatesZeroCarbon,
  useGroupZeroCarbonStatistics,
} from '~/hooks/useZeroCarbon/useGroupZeroCarbon';
import { AttachCertificateDialog } from '~/pages/Portal/Admin/Groups/AttachCertificateDialog';
import { CertificateContractsDialog } from '~/pages/Portal/Admin/Groups/CertificateContractsDialog';
import { downloadCertificate } from '~/services/GroupZeroCarbon';
import { openLinkInNewTab } from '~/utils/openLinkInNewTab';
import { AddCertificateDialog } from '~/pages/Portal/Admin/Groups/AddCertificate';
import {
  RulesTerminationContractsGroup,
  RulesTerminationContractsGroupType,
} from '~/pages/Portal/TerminationRequests/RulesTerminationContractsGroup';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';
import { updateUrlParams } from '~/utils/updateUrlParams';
import { PAGE_SIZE } from '~/constants';

export interface Item {
  label: string;
  value: string;
  codigo: string;
  cnpj: string;
  name: string;
}

type SegmentoVendaResponsavel = {
  id_segmento_venda: number;
  id_responsavel?: number;
};

interface GroupFormData {
  nm_grupoeconomico: string;
  id_customer_success?: number;
  segmentos_venda_responsavel?: SegmentoVendaResponsavel[];
  aviso_previo_em_meses?: number;
  multa?: number;
  dia_limite_solicitar_rescisao?: number;
}

export const GroupForm: React.VFC = () => {
  const toast = useToast();
  const history = useHistory();
  const queryParams = useQueryParams();
  const groupId = queryParams.get('groupId');
  const isEdition = !!groupId;
  const features = useFeatureFlags();
  const [group, setGroup] = useState<Group | undefined>(undefined);
  const [status, setStatus] = useState<boolean>(true);
  const [companies, setCompanies] = useState<Item[]>([]);
  const [selectedCompanies, setSelectedCompanies] = useState<Item[]>([]);
  const { register, handleSubmit, setValue, formState, getValues, watch } =
    useForm();
  const { errors } = formState;
  const [listaSegmentos, setListaSegmentos] = useState<
    SegmentosVendaResponsavelAsView[]
  >([]);
  const [segmentoVenda, setSegmentoVenda] = useState<SelectItem[]>([]);
  const [segmentoVendaFiltrada, setSegmentoVendaFiltrada] = useState<
    SelectItem[]
  >([]);
  const [customerSuccess, setCustomerSuccess] = useState<SelectItem[]>([]);
  const [gerenteContas, setGerenteContas] = useState<SelectItem[]>([]);
  const segmentoVendas = watch('segmento_venda');
  const [segmentosVendaResponsavel, setSegmentosVendaResponsavel] = useState<
    SegmentoVendaResponsavel[]
  >([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingDownload, setIsFetchingDownload] = useState(false);
  const [parametros, setParametros] = useState(() => {
    return {
      pagina: '1',
      paginacao: PAGE_SIZE.toString(),
    };
  });
  const {
    data: certificates,
    isLoading: certificatesLoading,
    refetch: refetchCertificates,
  } = useGroupCertificatesZeroCarbon(groupId!);
  const { data: statistics, isLoading: statisticsLoading } =
    useGroupZeroCarbonStatistics(groupId!);

  const { data: usersInGroup, isLoading: usersInGroupLoading } =
    useUsersByGroup(
      groupId!,
      Number(parametros.pagina),
      Number(parametros.paginacao),
      {
        enabled: isEdition,
      },
    );

  const [rescisaoContratosObj, setRescisaoContratosObj] =
    useState<RulesTerminationContractsGroupType>({});

  useEffect(() => {
    getCompaniesAsSelect(groupId).then(response => {
      setCompanies(response);
    });
    if (isEdition) {
      getGroupById(groupId).then(response => {
        setGroup(response);
        setRescisaoContratosObj({
          dia_limite_solicitar_rescisao: response.dia_limite_solicitar_rescisao,
          multa: Number(response.multa),
          aviso_previo_em_meses: response.aviso_previo_em_meses,
        });
      });
      getSegmentoResppnsavelById(groupId).then(res => {
        res.customer_success &&
          setValue('customer_success', res.customer_success.id);
        res.segmentos_venda_responsavel.length &&
          setListaSegmentos(res.segmentos_venda_responsavel);
      });
      getCompaniesByGroupAsSelect(Number(groupId)).then(response => {
        setSelectedCompanies(response);
      });
    }
  }, [groupId]);

  useEffect(() => {
    if (group) {
      setValue('name', group?.nm_grupoeconomico);
      setValue('status', group?.status || false);
      setStatus(group?.status);
    }
  }, [group]);

  useEffect(() => {
    getSalesSegmentAsSelect().then(res => {
      setSegmentoVenda(res);
      setSegmentoVendaFiltrada(res);
    });
    getCustomerSuccessAsSelect().then(res => {
      setCustomerSuccess(res);
    });
  }, []);

  useEffect(() => {
    if (segmentoVendas) {
      getAccountManagerAsSelect(segmentoVendas).then(res => {
        setGerenteContas(res);
      });
    } else {
      setGerenteContas([]);
    }
  }, [segmentoVendas]);

  const handleSelectedItemsChange = (items?: Item[]) => {
    if (items) {
      setSelectedCompanies(items);
    }
  };

  const handleRemoveSelectedItem = (itemsId: string) => {
    setSelectedCompanies(
      selectedCompanies.filter(item => item.value !== itemsId),
    );
  };

  async function handleCreate(formData: any) {
    if (!validar(formData)) return;
    const companyIds = selectedCompanies.map(item => item.value);
    const segmentos_venda = listaSegmentos.map(segmento => ({
      id_segmento_venda: Number(segmento.segmento.value),
      id_responsavel: segmento.responsavel
        ? Number(segmento.responsavel.value)
        : undefined,
    }));
    const hasContractTerminationRules = Object.values(
      rescisaoContratosObj,
    ).some(value => value !== 0);

    let content: GroupFormData = {
      nm_grupoeconomico: formData.name,
    };
    if (formData.customer_success) {
      content = {
        ...content,
        id_customer_success: Number(formData.customer_success),
      };
    }

    if (segmentos_venda.length) {
      content = {
        ...content,
        segmentos_venda_responsavel: segmentos_venda,
      };
    }
    if (hasContractTerminationRules) {
      content = {
        ...content,
        aviso_previo_em_meses: rescisaoContratosObj.aviso_previo_em_meses,
        multa: rescisaoContratosObj.multa,
        dia_limite_solicitar_rescisao:
          rescisaoContratosObj.dia_limite_solicitar_rescisao,
      };
    }
    setIsFetching(true);
    try {
      if (isEdition) {
        await api.put(`/grupoeconomico/${group?.id_grupoeconomico}`, content);

        await api.put(
          `/grupoeconomico/${group?.id_grupoeconomico}/empresas`,
          companyIds,
        );
      } else {
        const { data } = await api.post('/grupoeconomico', content);

        if (data) {
          await api.put(
            `/grupoeconomico/${data.id_grupoeconomico}/empresas`,
            companyIds,
          );
        }
      }

      toast({
        title: `Grupo ${isEdition ? 'alterado' : 'criado'}`,
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      queryClient.invalidateQueries('groups');
      queryClient.invalidateQueries('companies');
      queryClient.invalidateQueries('company');
      queryClient.invalidateQueries('contract');
      queryClient.invalidateQueries(['group_zero_carbon_statistics', groupId]);
      queryClient.invalidateQueries([
        'group_certificates_zero_carbon',
        groupId,
      ]);
      setIsFetching(false);
      history.goBack();
    } catch (e) {
      toast({
        title: `Erro ao ${isEdition ? 'salvar' : 'criar'} grupo`,
        description: 'Tente novamente',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      setIsFetching(false);
    }
  }

  const adicionarSegmento = () => {
    const segmento = getValues('segmento_venda');
    if (validaAdicionarSegmento(segmento)) {
      setValue('segmento_venda', '');
      setValue('responsavel', '');
      return;
    }
    const responsavel = getValues('responsavel');
    listaSegmentos.push({
      segmento: { value: segmento, label: getSegmento(segmento) || '' },
      responsavel: responsavel
        ? {
            value: responsavel,
            label: getResponsavel(responsavel) || '',
          }
        : undefined,
    });
    setListaSegmentos(listaSegmentos);
    setValue('segmento_venda', '');
    setValue('responsavel', '');
  };

  const validaAdicionarSegmento = (segmento: string) => {
    if (listaSegmentos.length) {
      const segmentoExiste = listaSegmentos.filter(
        it => it.segmento.value.toString() === segmento.toString(),
      );
      if (segmentoExiste.length) {
        toast({
          title: `Segmento de venda ${segmentoExiste[0].segmento.label} já adicionado ao grupo`,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      }
      return !!segmentoExiste.length;
    }
    return false;
  };

  const removerSegmento = (id: string) => {
    const novaLista = listaSegmentos.filter(
      segmento => segmento.segmento.value.toString() !== id.toString(),
    );
    setListaSegmentos([...novaLista]);
  };

  const getResponsavel = (id: string) => {
    const responsavel = gerenteContas.find(
      it => it.value.toString() === id.toString(),
    );
    return responsavel?.label;
  };

  const getSegmento = (id: number) => {
    const segmento = segmentoVenda.find(
      it => it.value.toString() === id.toString(),
    );
    return segmento?.label;
  };

  const downloadArquivo = (
    id: string,
    tipo: 'certificadora' | 'validadora',
  ) => {
    setIsFetchingDownload(true);
    downloadCertificate(id, tipo)
      .then(r => {
        if (r?.data?.size > 0) {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        } else {
          toast({
            title: r?.data?.message,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .catch(() => {
        toast({
          title: 'Documento não encontrado',
          description: 'Entre em contato para mais informações',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => {
        setIsFetchingDownload(false);
      });
  };

  const validar = (formData: any) => {
    if (!formData.name) {
      toast({
        title: 'Preencha o campo "Nome" na aba "Dados Gerais".',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return false;
    }
    const hasContractTerminationRules = Object.values(
      rescisaoContratosObj,
    ).some(value => value !== 0);
    if (
      features.solicitarRescisaoContratosEnabled &&
      hasContractTerminationRules
    ) {
      const multaValida = rescisaoContratosObj.multa
        ? rescisaoContratosObj.multa <= 999.99
        : false;
      const rescisaoValida =
        !!rescisaoContratosObj.aviso_previo_em_meses &&
        !!rescisaoContratosObj.multa &&
        !!rescisaoContratosObj.dia_limite_solicitar_rescisao;
      if (!rescisaoValida || !multaValida) {
        toast({
          title:
            'Preencha corretamente os campos da aba "Regras para Rescisão de Contratos".',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        return false;
      }
    }
    return true;
  };

  return (
    <Stack as="form" onSubmit={handleSubmit(handleCreate)}>
      <Flex flexDir="column" justify="space-between" height="fit-content">
        <Flex flexDir="column" px="8" py="4" minH="calc(100vh - 127px)">
          <Heading hasBackButton>
            {isEdition ? 'Editar Grupo' : 'Criar Grupo'}
          </Heading>
          {isEdition && (
            <Text fontSize="14px" fontWeight="bold" mt={2} ps="38px">
              Grupo econômico: {group?.nm_grupoeconomico}
            </Text>
          )}
          <Flex
            flexDir={{ md: 'row', sm: 'column' }}
            w="100%"
            py={9}
            gridGap="12"
          >
            <Stack gridGap={6} bg="white" w="100%">
              <Tabs
                defaultIndex={Number(queryParams.get('tab')) || 0}
                variant="enclosed"
                onChange={index => {
                  isEdition &&
                    updateUrlParams(
                      { tab: index.toString(), groupId },
                      history,
                    );
                }}
              >
                <TabList>
                  <Tab
                    _selected={{
                      fontWeight: '600',
                      border: '1px solid #E2E8F0',
                    }}
                  >
                    Dados Gerais
                  </Tab>
                  <Tab
                    _selected={{
                      fontWeight: '600',
                      border: '1px solid #E2E8F0',
                    }}
                  >
                    Customer Success
                  </Tab>
                  <Tab
                    _selected={{
                      fontWeight: '600',
                      border: '1px solid #E2E8F0',
                    }}
                  >
                    <HStack gridGap={1}>
                      <Text>Segmentos de venda e Responsável comercial </Text>
                      <Tooltip
                        hasArrow
                        label="Selecione quem são os gerentes de contas"
                        bg="black"
                        rounded="md"
                        placement="top"
                        shouldWrapChildren
                      >
                        <Icon as={FaInfoCircle} boxSize={4} color="gray.900" />
                      </Tooltip>
                    </HStack>
                  </Tab>
                  <Tab
                    _selected={{
                      fontWeight: '600',
                      border: '1px solid #E2E8F0',
                    }}
                  >
                    Zero Carbon
                  </Tab>
                  {features.solicitarRescisaoContratosEnabled && (
                    <Tab
                      _selected={{
                        fontWeight: '600',
                        border: '1px solid #E2E8F0',
                      }}
                    >
                      Regras para Rescisão de Contratos
                    </Tab>
                  )}
                  {isEdition && (
                    <Tab
                      _selected={{
                        fontWeight: '600',
                        border: '1px solid #E2E8F0',
                      }}
                    >
                      Usuários do Grupo
                    </Tab>
                  )}
                </TabList>
                <Card
                  borderRadius={0}
                  width="100%"
                  content={
                    <TabPanels>
                      <TabPanel>
                        <Stack gridGap={4} w="70%">
                          <Input
                            name="name"
                            type="text"
                            label="Nome"
                            register={register}
                            fontSize="15px"
                          />
                          <FormControl
                            isInvalid={errors.empresas}
                            marginTop="auto"
                          >
                            <FormLabel fontSize="14px">Empresas</FormLabel>
                            <MultiSelect
                              value={selectedCompanies}
                              options={companies}
                              onChange={(changes: Item[]) =>
                                handleSelectedItemsChange(changes)
                              }
                              labelledBy="Selecione"
                              overrideStrings={MultiSelectStrings}
                            />
                          </FormControl>
                          <Table type="secondary">
                            <Thead>
                              <Tr>
                                <Th p="0.5rem !important" w="10%">
                                  Código
                                </Th>
                                <Th p="0.5rem !important" w="10%">
                                  CNPJ
                                </Th>
                                <Th p="0.5rem !important">Empresa</Th>
                                <Th p="0.5rem !important" w="15%">
                                  Ações
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {selectedCompanies?.length > 0 ? (
                                selectedCompanies?.map(empresa => (
                                  <Tr key={empresa.value}>
                                    <Td
                                      fontSize="15px"
                                      whiteSpace="nowrap"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      maxWidth="200px"
                                      p="0.5rem !important"
                                      style={{ borderColor: '#e5e5e6' }}
                                    >
                                      {empresa.codigo}
                                    </Td>
                                    <Td
                                      fontSize="15px"
                                      whiteSpace="nowrap"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      maxWidth="200px"
                                      p="0.5rem !important"
                                      style={{ borderColor: '#e5e5e6' }}
                                    >
                                      {empresa.cnpj}
                                    </Td>
                                    <Td
                                      fontSize="15px"
                                      whiteSpace="nowrap"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      maxWidth="200px"
                                      p="0.5rem !important"
                                      style={{ borderColor: '#e5e5e6' }}
                                    >
                                      <Tooltip
                                        label={empresa.name}
                                        placement="top-start"
                                      >
                                        {empresa.name}
                                      </Tooltip>
                                    </Td>
                                    <Td
                                      p="0.5rem !important"
                                      style={{ borderColor: '#e5e5e6' }}
                                    >
                                      <Tooltip label="Remover" placement="top">
                                        <IconButton
                                          w="25px"
                                          fontSize="20px"
                                          background="transparent"
                                          aria-label="Remove item"
                                          icon={<Icon as={FiTrash} />}
                                          onClick={() =>
                                            handleRemoveSelectedItem(
                                              empresa.value,
                                            )
                                          }
                                        />
                                      </Tooltip>
                                    </Td>
                                  </Tr>
                                ))
                              ) : (
                                <Tr>
                                  <Td
                                    align="center"
                                    valign="middle"
                                    h="100%"
                                    colSpan={4}
                                  >
                                    Não há dados a serem apresentados
                                  </Td>
                                </Tr>
                              )}
                            </Tbody>
                          </Table>
                        </Stack>
                      </TabPanel>
                      <TabPanel>
                        <Stack w="70%">
                          <Flex justifyContent="space-between" fontSize="14px">
                            <FormLabel m={0}>Customer Success</FormLabel>
                            <Tooltip
                              hasArrow
                              label="Apenas para clientes estratégicos definidos pela área"
                              bg="black"
                              rounded="md"
                              placement="top"
                              shouldWrapChildren
                            >
                              <Icon
                                as={FaInfoCircle}
                                boxSize={4}
                                color="gray.900"
                              />
                            </Tooltip>
                          </Flex>
                          <Select
                            name="customer_success"
                            placeholder="Selecione"
                            register={register}
                            error={errors.customer_success}
                            fontSize="15px"
                          >
                            {customerSuccess.length &&
                              customerSuccess?.map(state => (
                                <option key={state.value} value={state.value}>
                                  {state.label}
                                </option>
                              ))}
                          </Select>
                        </Stack>
                      </TabPanel>
                      <TabPanel>
                        <Stack gridGap={4} w="70%">
                          <HStack>
                            <Select
                              name="segmento_venda"
                              placeholder="Selecione"
                              register={register}
                              error={errors.segmento_venda}
                              fontSize="15px"
                              label="Segmento de venda"
                            >
                              {segmentoVendaFiltrada.length &&
                                segmentoVendaFiltrada?.map(segmento => (
                                  <option
                                    key={segmento.value}
                                    value={segmento.value}
                                  >
                                    {segmento.label}
                                  </option>
                                ))}
                            </Select>
                            <Select
                              name="responsavel"
                              placeholder="Selecione"
                              register={register}
                              error={errors.responsavel}
                              fontSize="15px"
                              label="Responsável pela conta (grupo)"
                            >
                              {gerenteContas.length &&
                                gerenteContas?.map(responsavel => (
                                  <option
                                    key={responsavel.value}
                                    value={responsavel.value}
                                  >
                                    {responsavel.label}
                                  </option>
                                ))}
                            </Select>
                            <Button
                              variant="secondary"
                              w={150}
                              marginTop="auto !important"
                              onClick={() => adicionarSegmento()}
                              isDisabled={!segmentoVendas}
                            >
                              Adicionar
                            </Button>
                          </HStack>
                          {listaSegmentos.length && (
                            <Table type="secondary">
                              <Thead>
                                <Tr>
                                  <Th whiteSpace="nowrap">
                                    Segmento de vendas
                                  </Th>
                                  <Th whiteSpace="nowrap">
                                    Responsável pela conta
                                  </Th>
                                  <Th textAlign="center" w={100}>
                                    Ações
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {listaSegmentos.map(segmentos => (
                                  <Tr key={segmentos.segmento.value}>
                                    <Td>{segmentos.segmento.label}</Td>
                                    <Td>
                                      {segmentos.responsavel?.label ?? '-'}
                                    </Td>
                                    <Td textAlign="center">
                                      <Icon
                                        as={FaTrash}
                                        boxSize={4}
                                        color="gray.900"
                                        cursor="pointer"
                                        onClick={() =>
                                          removerSegmento(
                                            segmentos.segmento.value,
                                          )
                                        }
                                      />
                                    </Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          )}
                        </Stack>
                      </TabPanel>
                      <TabPanel>
                        <Card
                          width="fit-content"
                          content={
                            <HStack
                              p={1}
                              gridGap={3}
                              divider={
                                <Center height="60px">
                                  <Divider orientation="vertical" />
                                </Center>
                              }
                            >
                              <Stack gridGap={2}>
                                <Text fontSize="15px" fontWeight="bold">
                                  Valores a compensar
                                </Text>
                                <HStack alignItems="baseline" gridGap={0}>
                                  <Heading>
                                    {statistics?.formattedTotalConsumidoCo2Kg ||
                                      '- '}
                                  </Heading>
                                  <Text
                                    fontSize="12px"
                                    marginStart="0.1rem !important"
                                  >
                                    kgCO2e
                                  </Text>
                                </HStack>
                              </Stack>
                              <Stack gridGap={2}>
                                <Text fontSize="15px" fontWeight="bold">
                                  Compensado
                                </Text>
                                <HStack alignItems="baseline" gridGap={0}>
                                  <Heading>
                                    {statistics?.formattedTotalCompensadoCo2T ||
                                      '- '}
                                  </Heading>
                                  <Text
                                    fontSize="12px"
                                    marginStart="0.1rem !important"
                                  >
                                    tCO2e
                                  </Text>
                                </HStack>
                              </Stack>
                              <Stack gridGap={2}>
                                <Text fontSize="15px" fontWeight="bold">
                                  Saldo para emissão de certificado
                                </Text>
                                <HStack alignItems="baseline" gridGap={0}>
                                  <Heading>
                                    {statistics?.formattedSaldoCo2Kg || '- '}
                                  </Heading>
                                  <Text
                                    fontSize="12px"
                                    marginStart="0.1rem !important"
                                  >
                                    kgCO2e
                                  </Text>
                                </HStack>
                              </Stack>
                            </HStack>
                          }
                        />
                        <Stack mt={5}>
                          <HStack justifyContent="space-between">
                            <Text fontSize="15px" fontWeight="bold">
                              Certificados
                            </Text>
                            <HStack gridGap={2}>
                              <AddCertificateDialog id_grupo={groupId!} />
                              <ApplyForCertificateDialog id_grupo={groupId!} />
                            </HStack>
                          </HStack>
                          <Table type="secondary">
                            <Thead>
                              <Tr>
                                <Th>CERTIFICADOS</Th>
                                <Th w="30%">PROJETO</Th>
                                <Th>DATA DE CERTIFICAÇÃO</Th>
                                <Th>QTDE DE EQUIPAMENTOS</Th>
                                <Th>CONSUMO CO2 TOTAL</Th>
                                <Th>CONTRATOS</Th>
                                <Th>
                                  CERTIFICADO{' '}
                                  {isFetchingDownload && (
                                    <Spinner ms={1} size="sm" />
                                  )}
                                </Th>
                                <Th>SITUAÇÃO</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {!!certificates && certificates.results.length ? (
                                certificates.results.map(it => (
                                  <Tr>
                                    <Td>
                                      <Tooltip
                                        hasArrow
                                        label={it.codigo_certificado}
                                        bg="black"
                                        shouldWrapChildren
                                      >
                                        {it.codigo_certificado
                                          ? it.codigo_certificado.length > 50
                                            ? `${it.codigo_certificado.slice(
                                                0,
                                                50,
                                              )}...`
                                            : it.codigo_certificado
                                          : '-'}
                                      </Tooltip>
                                    </Td>
                                    <Td
                                      whiteSpace="nowrap"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      maxWidth="200px"
                                    >
                                      <Tooltip
                                        label={it.projeto}
                                        placement="top-start"
                                      >
                                        {it.projeto || '-'}
                                      </Tooltip>
                                    </Td>
                                    <Td>
                                      {it.formattedDataDeCertificacao || '-'}
                                    </Td>
                                    <Td>{it.quantidade_equipamentos}</Td>
                                    <Td>
                                      {it.formattedConsumoTotalCo2Kg}kg CO2e
                                    </Td>
                                    <Td>
                                      <CertificateContractsDialog
                                        id_projeto_co2={it.id.toString()}
                                        codigo_certificado={
                                          it.codigo_certificado
                                        }
                                        link_certificado={it.link_certificado}
                                      />
                                    </Td>
                                    <Td>
                                      {it.status !== 0 ? (
                                        <HStack whiteSpace="nowrap">
                                          <IconButton
                                            marginRight={2}
                                            aria-label="Abrir Certificado"
                                            icon={<Icon as={FiExternalLink} />}
                                            onClick={() =>
                                              openLinkInNewTab(
                                                `${it.link_certificado}`,
                                              )
                                            }
                                          />
                                          <Menu
                                            fontSize="md"
                                            isDisabled={isFetchingDownload}
                                          >
                                            <MenuList>
                                              <MenuItem
                                                onClick={() =>
                                                  downloadArquivo(
                                                    it.id.toString(),
                                                    'certificadora',
                                                  )
                                                }
                                              >
                                                <Icon as={FiDownload} me={1} />
                                                Certificadora
                                              </MenuItem>
                                              <MenuItem
                                                onClick={() =>
                                                  downloadArquivo(
                                                    it.id.toString(),
                                                    'validadora',
                                                  )
                                                }
                                              >
                                                <Icon as={FiDownload} me={1} />
                                                Validadora
                                              </MenuItem>
                                            </MenuList>
                                          </Menu>
                                        </HStack>
                                      ) : (
                                        <AttachCertificateDialog
                                          id_projeto_co2={it.id.toString()}
                                          possui_carta={it.possui_carta}
                                        />
                                      )}
                                    </Td>
                                    <Td>
                                      <StatusBadge
                                        variant={it.statusColor}
                                        width="fit-content"
                                      >
                                        {it.formattedStatus}
                                      </StatusBadge>
                                    </Td>
                                  </Tr>
                                ))
                              ) : (
                                <Tr>
                                  <Td textAlign="center" colSpan={6}>
                                    Nenhum item encontrado.
                                  </Td>
                                </Tr>
                              )}
                            </Tbody>
                          </Table>
                        </Stack>
                      </TabPanel>
                      {features.solicitarRescisaoContratosEnabled && (
                        <TabPanel>
                          <RulesTerminationContractsGroup
                            obj={rescisaoContratosObj}
                            alteraObj={obj => {
                              setRescisaoContratosObj(obj);
                            }}
                          />
                        </TabPanel>
                      )}
                      {isEdition && (
                        <TabPanel>
                          <Table type="secondary">
                            <Thead>
                              <Tr>
                                <Th textAlign="center">TIPO DE FUNÇÃO</Th>
                                <Th>NOME</Th>
                                <Th textTransform="none">E-MAIL</Th>
                                <Th textAlign="center">PERFIL DE ACESSO</Th>
                                <Th textAlign="center">TIPO DE USUÁRIO</Th>
                                <Th textAlign="center">RESP. POR CONTRATOS</Th>
                                <Th textAlign="center">STATUS</Th>
                                <Th textAlign="center">BLOQUEADO</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {usersInGroup &&
                              usersInGroup.results.length > 0 ? (
                                usersInGroup?.results.map(user => (
                                  <Tr
                                    key={`${user.id_usuario}-${user.tipo_usuario}`}
                                  >
                                    <Td textAlign="center">
                                      {user.tipo_usuario}
                                    </Td>
                                    <Td>
                                      <Link
                                        to={`/portal/admin/users/form?userId=${user.id_usuario}&type=${user.tipo_usuario}`}
                                      >
                                        <Text
                                          _hover={{
                                            color: 'gray.900',
                                            textDecoration: 'underline',
                                          }}
                                        >
                                          {user.nome_usuario || '-'}
                                        </Text>
                                      </Link>
                                    </Td>
                                    <Td>{user.email_usuario}</Td>
                                    <Td textAlign="center">
                                      {user.perfil_acesso}
                                    </Td>
                                    <Td textAlign="center">
                                      {user.nm_funcao || '-'}
                                    </Td>
                                    <Td textAlign="center">
                                      {user.responsavel_por_contrato
                                        ? 'Sim'
                                        : 'Não'}
                                    </Td>
                                    <Td textAlign="center">
                                      <StatusBadge
                                        variant={
                                          user.tp_situacao ? 'green' : 'red'
                                        }
                                      >
                                        {user.tp_situacao ? 'Ativo' : 'Inativo'}
                                      </StatusBadge>
                                    </Td>
                                    <Td textAlign="center">
                                      <StatusBadge
                                        variant={
                                          user.bloqueado ? 'red' : 'green'
                                        }
                                      >
                                        {user.bloqueado ? 'SIM' : 'NÃO'}
                                      </StatusBadge>
                                    </Td>
                                  </Tr>
                                ))
                              ) : (
                                <Tr>
                                  <Td colSpan={7} textAlign="center">
                                    Não há dados a serem apresentados
                                  </Td>
                                </Tr>
                              )}
                            </Tbody>
                          </Table>
                          <Flex justify="flex-end">
                            {usersInGroup && (
                              <Pagination
                                totalCountOfRegisters={usersInGroup.count}
                                currentPage={Number(parametros.pagina) ?? 1}
                                onPageChange={_page => {
                                  setParametros({
                                    ...parametros,
                                    pagina: _page.toString(),
                                  });
                                }}
                                onPageSizeChange={e =>
                                  setParametros({
                                    ...parametros,
                                    paginacao: e.target.value,
                                    pagina: '1',
                                  })
                                }
                                registersPerPage={
                                  Number(parametros.paginacao) ?? PAGE_SIZE
                                }
                              />
                            )}
                          </Flex>
                        </TabPanel>
                      )}
                    </TabPanels>
                  }
                />
              </Tabs>
            </Stack>
          </Flex>
        </Flex>
      </Flex>
      <Footer>
        <Button variant="secondary" onClick={() => history.goBack()}>
          Cancelar
        </Button>
        <Button type="submit" isDisabled={isFetching}>
          {isEdition ? 'Salvar Alterações' : 'Cadastrar'}
          {isFetching && <Spinner ml={2} />}
        </Button>
      </Footer>
    </Stack>
  );
};
